export enum MultiSelectFilterType {
  String,
  MultiSelectItem
}
